import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { FiInfo, FiZap, FiAlertTriangle, FiAlertCircle } from 'react-icons/fi';

const CALLOUT_TYPES = {
  note: {
    icon: FiInfo,
    label: 'Note',
    className: 'callout-note',
    emoji: '📝',
  },
  tip: {
    icon: FiZap,
    label: 'Tip',
    className: 'callout-tip',
    emoji: '💡',
  },
  warning: {
    icon: FiAlertTriangle,
    label: 'Warning',
    className: 'callout-warning',
    emoji: '⚠️',
  },
  danger: {
    icon: FiAlertCircle,
    label: 'Danger',
    className: 'callout-danger',
    emoji: '🚨',
  },
};

// Callout Node View Component
const CalloutNodeView = ({ node, updateAttributes, selected }) => {
  const { type, title, content } = node.attrs;
  const calloutConfig = CALLOUT_TYPES[type] || CALLOUT_TYPES.note;
  const Icon = calloutConfig.icon;

  const handleChange = (field, value) => {
    updateAttributes({ [field]: value });
  };

  return (
    <NodeViewWrapper className={`callout-block ${calloutConfig.className} ${selected ? 'selected' : ''}`}>
      <div className="callout-type-selector">
        {Object.entries(CALLOUT_TYPES).map(([key, config]) => (
          <button
            key={key}
            type="button"
            className={`callout-type-btn ${type === key ? 'active' : ''}`}
            onClick={() => handleChange('type', key)}
            title={config.label}
          >
            {config.emoji}
          </button>
        ))}
      </div>
      <div className="callout-header">
        <Icon size={18} />
        <input
          type="text"
          value={title}
          onChange={(e) => handleChange('title', e.target.value)}
          placeholder={`${calloutConfig.label}...`}
          className="callout-title-input"
        />
      </div>
      <div className="callout-content">
        <textarea
          value={content}
          onChange={(e) => handleChange('content', e.target.value)}
          placeholder="Enter callout content..."
          className="callout-content-input"
          rows={3}
        />
      </div>
    </NodeViewWrapper>
  );
};

// Callout Extension
export const Callout = Node.create({
  name: 'callout',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      type: {
        default: 'note',
      },
      title: {
        default: 'Note',
      },
      content: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="callout"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'callout' }), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CalloutNodeView);
  },

  addCommands() {
    return {
      insertCallout:
        (attrs = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              type: attrs.type || 'note',
              title: attrs.title || 'Note',
              content: attrs.content || 'Enter your note here...',
            },
          });
        },
    };
  },
});

export default Callout;
